var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "15px",
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_email") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CleverSparky-Web-App-V2.0---UI-Updates-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Support",
    transform: "translate(-18.000000, -198.000000)",
    stroke: "#666162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/Profile/email",
    transform: "translate(19.000000, 199.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_email"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7142857,13.4922667 L1.28571429,13.4922667 C0.717428571,13.4922667 0.257142857,13.0281926 0.257142857,12.4552296 L0.257142857,1.29619259 C0.257142857,0.723748148 0.717428571,0.259155556 1.28571429,0.259155556 L16.7142857,0.259155556 C17.2825714,0.259155556 17.7428571,0.723748148 17.7428571,1.29619259 L17.7428571,12.4552296 C17.7428571,13.0281926 17.2825714,13.4922667 16.7142857,13.4922667 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.41868,0.670340741 L8.86428,9.17715556 C8.92393714,9.23782222 9.00982286,9.23782222 9.06999429,9.17767407 L17.5819371,0.670340741",
    id: "Stroke-3"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.b33304b8201479a8805b6eb103f27f3b.svg";
export { ForwardRef as ReactComponent };